import axios from "axios";

// Base API host from environment
const API_HOST = process.env.REACT_APP_API_HOST;
axios.defaults.baseURL = API_HOST;

const axiosInstance = axios.create({
  headers: {
    Accept: "application/json",
  },
});

// Attach token to outgoing requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Rutas públicas donde NO debe redirigirse a /login ante un 401
const PUBLIC_PATHS = ['/login', '/register', '/recover-password', '/home', '/help', '/'];
const PUBLIC_PATH_PREFIXES = ['/register/', '/reset-password/'];

function isPublicPath(path) {
  if (!path) return false;
  if (PUBLIC_PATHS.includes(path)) return true;
  return PUBLIC_PATH_PREFIXES.some((p) => path.startsWith(p));
}

// Centralized response error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      // Clear token and redirect to login for unauthorized responses,
      // but only when the user is on a protected route.
      try { localStorage.removeItem('token'); } catch (e) {}
      const loginPath = '/login';
      if (typeof window !== 'undefined') {
        const currentPath = window.location.pathname;
        if (currentPath !== loginPath && !isPublicPath(currentPath)) {
          window.location.href = loginPath;
        }
      }
    }

    if (status === 500) {
      // Optional: show global notification to the user
      // console.error('Server error', error);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;

